import { useState } from 'react';
import Spinner from '../../components/Reusable/Spinner';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import usePostHook from '../../customHooks/usePostHook';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import loadable from '@loadable/component';
//@ts-ignore
import { usePDFPrintHook } from '@careinfo/layout';
import { useLocation, useSearchParams } from 'react-router-dom';
import CreateIcon from '../../Icons/CreateIcon';
import { queryClient } from '../../router';

const CreateConsignmentComponent = loadable(
  () => import('../../components/Consignment/CreateConsignment')
);
const CreateConsignment = () => {
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false);
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [selectedConsignment, setSelectedConsignment] = useState(null);
  const [searchParams, setSearchParms] = useSearchParams();

  const { state } = useLocation();
  const validOrders = state?.validOrders;

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['Consignment'],
    navigateURL: '',
  });

  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { data: currentMerchantProfile, isLoading: isMerchantProfileLoading } =
    useGetHook({
      queryKey: [`current-merchant-profile`],
      url: `${APIS.CURRENT_MERCHANT}`,
      params: {},
    });

  const handleCreate = async (values: any, setError: any) => {
    const url = validOrders
      ? `${APIS.ORDER}daraz-bulk-commit/`
      : `${APIS.ORDER}`;
    const formatContact = (number) => {
      if (!number) return null;
      return number.startsWith('+977') ? number : `+977${number}`;
    };

    let formData = {
      ...values,
      receiver_phone_number: formatContact(values?.receiver_phone_number),
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 201) {
        setOpenPrintPopup(true);
        setSelectedConsignment(res?.data?.id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const {
    mutateAsync: createCustomerMutateAsync,
    isPostLoading: createCustomerLoading,
  } = usePostHook({
    queryKey: ['customers'],
    navigateURL: '/create',
  });

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    const formatContact = (number) => {
      if (!number) return null;
      return number.startsWith('+977') ? number : `+977${number}`;
    };
    let formData = {
      ...values,
      primary_contact: formatContact(values?.primary_contact),
      secondary_contact: values?.secondary_contact
        ? formatContact(values.secondary_contact)
        : null,
    };
    try {
      await createCustomerMutateAsync({ url, formData, setError });
      queryClient.refetchQueries();
    } catch (err) {
      console.log(err);
    }
  };

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handleLabelPrintDownload = async () => {
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: [selectedConsignment],
    };
    try {
      const res = await downloadPrint(url, formData);

      searchParams.delete('selectedItems');
      setSearchParms(searchParams);
    } catch (err) {
      console.log(err);
    }
  };

  const handleConsignmentReceiptDownload = async () => {
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: [selectedConsignment],
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete('selectedItems');
      setSearchParms(searchParams);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Consignment
        </span>
      </div>
      {isLoading || isMerchantProfileLoading ? (
        <Spinner />
      ) : (
        <CreateConsignmentComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          handleCreateCustomer={handleCreateCustomer}
          createCustomerLoading={createCustomerLoading}
          defaultBranch={profile?.default_branch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          handleLabelPrintDownload={handleLabelPrintDownload}
          handleConsignmentReceiptDownload={handleConsignmentReceiptDownload}
          isPrintLoading={isPrintLoading}
          currentMerchantProfile={currentMerchantProfile}
          validOrders={validOrders}
        />
      )}
    </>
  );
};

export default CreateConsignment;
